import { Controller } from "stimulus"
const EMAIL_REGEX = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i

export default class extends Controller {
  connect() {
    this.boxControls();
    let sendEmailVerificationBtn = document.getElementById("send-email-verification-btn")
    let verifyEmailBtn = document.getElementById("verify-email-btn")
    if (sendEmailVerificationBtn && verifyEmailBtn) {
      this.initializeFormValidation();
      sendEmailVerificationBtn.addEventListener("click", ()=> this.sendEmailVerification(sendEmailVerificationBtn))
      verifyEmailBtn.addEventListener("click", () => this.otpVerification(verifyEmailBtn))
    }
    this.togglesTaxInfos()
    document.querySelectorAll('input[name="agent_signup[is_us_taxpayer]"]').forEach(radio => {
      radio.addEventListener("change", () => this.togglesTaxInfos())
    })
    this.toggleBusinessType()
    document.querySelectorAll('input[name="agent_signup[type]"]').forEach(radio => {
      radio.addEventListener("change", () => this.toggleBusinessType())
    })
    this.toggleLicensedAgency()
    document.querySelectorAll('input[name="agent_signup[is_licensed_insurance_agency]"]').forEach(radio => {
      radio.addEventListener("change", () => this.toggleLicensedAgency())
    })
    this.element.querySelectorAll(".custom-file-input").forEach(input => {
      input.addEventListener("change", () => this.updateFileLabel(input))
    })
    this.element.addEventListener("submit", (event) => {
      setTimeout(() => {
        if (event.defaultPrevented) {
          this.hidePreparingOverlay()
          return
        }
        this.showPreparingOverlay()
      }, 0)
    })
  }
  initializeFormValidation() {
    let successToken = document.getElementById("success_token");
    if (successToken.value.trim()) {
      let sendEmailVerificationBtn = document.getElementById("send-email-verification-btn");
      this.setButtonLoading(sendEmailVerificationBtn, this.i18n("i18nVerified"), { keepDisabled: true, showSpinner: false })
      let passwordFieldsContainer = document.getElementById("password_fields_container");
      if (passwordFieldsContainer) passwordFieldsContainer.classList.remove("d-none")
    }
  }

  i18n(key) {
    const overlay = document.getElementById("agent-signup-loading-overlay")
    return (overlay && overlay.dataset[key]) || ""
  }

  showPreparingOverlay() {
    const overlay = document.getElementById("agent-signup-loading-overlay")
    if (overlay) {
      overlay.classList.remove("d-none")
      document.body.style.overflow = "hidden"
    }
    const submitBtn = this.element.querySelector('input[type="submit"], button[type="submit"]')
    if (submitBtn) submitBtn.disabled = true
  }

  hidePreparingOverlay() {
    const overlay = document.getElementById("agent-signup-loading-overlay")
    if (overlay) {
      overlay.classList.add("d-none")
      document.body.style.overflow = ""
    }
    const submitBtn = this.element.querySelector('input[type="submit"], button[type="submit"]')
    if (submitBtn) submitBtn.disabled = false
  }

  boxControls() { 
    let box3a = document.getElementById("agent_signup_box_3a")
    let box3a_llc_classification = document.getElementById("agent_signup_box_3a_llc_classification")
    this.box3aLlc(box3a);
    this.box3aOtherValue(box3a);
    this.box3bCheckbox(box3a);
    box3a.addEventListener("change", () => {
      this.box3aLlc(box3a)
      this.box3aOtherValue(box3a)
      this.box3bCheckbox(box3a)
    })
    box3a_llc_classification.addEventListener("change", () => {
      this.box3bCheckbox(box3a)
    })
  }

  box3bCheckbox(box3a) { 
    let box3b_checkbox_container = document.getElementById("box_3b_checkbox_container");
    let box3b_checkbox = document.getElementById("agent_signup_box_3b_checkbox")
    let box3a_llc_classification = document.getElementById("agent_signup_box_3a_llc_classification")
    if ((box3a.value === "llc" && box3a_llc_classification.value === "p") || (box3a.value === "partnership") || (box3a.value === "trust_or_estate")) {
      box3b_checkbox_container.classList.remove("d-none")
    } else {
      box3b_checkbox_container.classList.add("d-none")
      box3b_checkbox.checked = false
    }
  }

  box3aOtherValue(box3a) { 
    let box3a_other_value_container = document.getElementById("box_3a_other_value_container")
    let box3a_other_value = document.getElementById("agent_signup_box_3a_other_value")
    if (box3a.value === "other") {
      box3a_other_value_container.classList.remove("d-none")
    } else {
      box3a_other_value_container.classList.add("d-none")
      box3a_other_value.value = ""
    }
  }

  box3aLlc(box3a) { 
    let box3a_llc_classification = document.getElementById("agent_signup_box_3a_llc_classification")
    let box3a_llc_classification_container = document.getElementById("box_3a_llc_classification_container")
    if (box3a.value === "llc") {
      box3a_llc_classification_container.classList.remove("d-none")
    } else {
      box3a_llc_classification_container.classList.add("d-none")
      box3a_llc_classification.value = ""
    }
  }

  toggleBusinessType() {
    let typeRadio = document.querySelector('input[name="agent_signup[type]"]:checked')
    if (!typeRadio) return
    let isBusiness = typeRadio.value === "Business"
    let header = document.getElementById("business-information-header")
    if (header) header.textContent = isBusiness ? header.dataset.headingBusiness : header.dataset.headingAgent
    let agencyContainer = document.getElementById("is_licensed_insurance_agency_container")
    let agencyLabelEl = agencyContainer && agencyContainer.querySelector(':scope > label')
    if (agencyContainer && agencyLabelEl) {
      agencyLabelEl.textContent = isBusiness ? agencyContainer.dataset.labelAgency : agencyContainer.dataset.labelAgent
    }
  }

  toggleLicensedAgency() {
    let radio = document.querySelector('input[name="agent_signup[is_licensed_insurance_agency]"]:checked')
    let card = document.getElementById("e-and-o-policy-card")
    if (!radio || !card) return
    let isLicensed = radio.value === "true"
    card.classList.toggle("d-none", !isLicensed)
  }

  updateFileLabel(input) {
    let label = input.nextElementSibling
    if (!label || !label.classList.contains("custom-file-label")) return
    let names = Array.from(input.files).map(file => file.name).join(", ")
    label.textContent = names || label.dataset.placeholder
  }

  togglesTaxInfos() {
    this.toggleNonUsTaxDocument()
    this.toggleEin()
  }

  toggleNonUsTaxDocument() {
    let isUsTaxpayer = document.querySelector('input[name="agent_signup[is_us_taxpayer]"]:checked').value
    if (isUsTaxpayer === "false") {
      document.querySelector(".agent_signup_non_us_tax_document_pdf").classList.remove("d-none")
    } else {
      document.querySelector(".agent_signup_non_us_tax_document_pdf").classList.add("d-none")
    }
  }

  toggleEin() {
    let isUsTaxpayer = document.querySelector('input[name="agent_signup[is_us_taxpayer]"]:checked').value
    if (isUsTaxpayer === "true") {
      document.querySelector(".agent_signup_ein").classList.remove("d-none")
    } else {
      document.querySelector(".agent_signup_ein").classList.add("d-none")
    }
  }

  sendEmailVerification(sendEmailVerificationBtn) {
    this.setButtonLoading(sendEmailVerificationBtn, this.i18n("i18nSending"))
    let email = document.getElementById("agent_signup_email").value.trim()
    if (!this.validEmail(email)) { 
      this.clearButtonLoading(sendEmailVerificationBtn)
    }
    
    fetch(`/agent_signup/email_verification?email=${email}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        this.clearButtonLoading(sendEmailVerificationBtn)
        console.error(data.error)
        alert(data.error)
      } else {
        this.setButtonLoading(sendEmailVerificationBtn, this.i18n("i18nSent"), { keepDisabled: true, showSpinner: false })
        setTimeout(() => {
          this.clearButtonLoading(sendEmailVerificationBtn)
        }, 120000)
        let verificationCodeContainer = document.getElementById("verification_code_container")
        verificationCodeContainer.classList.remove("d-none")
      }
    });
  }

  otpVerification(otpVerificationBtn) {
    this.setButtonLoading(otpVerificationBtn, this.i18n("i18nVerifying"));
    let successToken = document.getElementById("success_token");
    let code = document.getElementById("verification_code").value.trim();
    let email = document.getElementById("agent_signup_email").value.trim();
    if (!this.validEmail(email) && code.length !== 6) {
      this.clearButtonLoading(otpVerificationBtn)
      alert(this.i18n("i18nInvalidEmailCode"))
      return
    }
    fetch(`/agent_signup/email_otp_verification?email=${email}&code=${code}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        this.clearButtonLoading(otpVerificationBtn)
        alert(data.error)
      }
      else {
        this.setButtonLoading(otpVerificationBtn, this.i18n("i18nVerified"), { keepDisabled: true, showSpinner: false })
        successToken.value = data.success_token
        let passwordFieldsContainer = document.getElementById("password_fields_container")
        if (passwordFieldsContainer) passwordFieldsContainer.classList.remove("d-none")
      }
    });
  }


  validEmail(email) {
    return EMAIL_REGEX.test(email.trim())
  }

  setButtonLoading(button, label, { keepDisabled = true, showSpinner = true } = {}) {
    if (!button.dataset.originalHtml) {
      button.dataset.originalHtml = button.innerHTML
    }
    button.disabled = keepDisabled
    if (showSpinner) {
      button.innerHTML = `
        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        ${label}
      `
    } else {
      button.textContent = label
    }
  }

  clearButtonLoading(button, label = null) {
    button.disabled = false
    button.innerHTML = button.dataset.originalHtml || label || this.i18n("i18nVerify")
  }
}